import React from 'react';

/**
 * Team Activity Summary Badge
 * 
 * Beautiful, concise summary of team activity for RSLs and ASMs.
 * Replaces the long list of individual submissions in the dropdown.
 * 
 * Features:
 * - Compact, branded design
 * - Shows total submission count
 * - Click → Opens TeamHierarchyModal
 * - PBFS green styling
 */
const TeamActivitySummary = ({ 
  submissionCount, 
  days = 7, 
  onClick,
  loading = false 
}) => {
  if (loading) {
    return (
      <div className="bg-[var(--pbfs-green)]/10 border-2 border-[var(--pbfs-green)]/30 rounded-lg p-3 animate-pulse">
        <div className="flex items-center gap-2">
          <div className="animate-spin text-xl">⚙️</div>
          <span className="text-sm text-[var(--pbfs-navy)]">Loading team activity...</span>
        </div>
      </div>
    );
  }
  
  if (submissionCount === 0) {
    return (
      <div className="bg-gray-100 border-2 border-gray-300 rounded-lg p-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl">📭</span>
            <div>
              <div className="font-semibold text-gray-700 text-sm">
                No team activity
              </div>
              <div className="text-xs text-gray-500">
                Last {days} days
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) onClick(e);
      }}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="bg-gradient-to-r from-[var(--pbfs-green)]/10 to-[var(--pbfs-blue)]/10 border-2 border-[var(--pbfs-green)] rounded-lg p-3 cursor-pointer hover:shadow-lg hover:scale-[1.02] transition-all group"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-[var(--pbfs-green)] text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold group-hover:scale-110 transition-transform">
            {submissionCount}
          </div>
          <div>
            <div className="font-bold text-[var(--pbfs-navy)] text-sm">
              Team Submissions
            </div>
            <div className="text-xs text-gray-600">
              Last {days} days • Click to view details
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamActivitySummary;

